import React from 'react';

import styles from './Events.m.sass';

import {Link} from 'react-router';
import {channelImageUrl} from '../../containers/channelUtils/ChannelImage';

import hordeIcon from './assets/horde.svg';
import allianceIcon from './assets/alliance.svg';
import RightArrowIcon from '-!svg-react-loader?name=RightArrowIcon!../../components/button/assets/arrow-right-accent.svg';

import withMediaQueries from '../../containers/withMediaQueries/withMediaQueries';
import AnnotatedPriceButton from '../annotatedPriceButton/AnnotatedPriceButton';

@withMediaQueries({collapsed: '(max-width: 991px)'}, {collapsed: false})
class Event extends React.PureComponent {
  render () {
    const {collapsed, name, description, price, slug} = this.props;

    return (
      <div className={styles.eventCol}>
        <div className={styles.event}>
          {!collapsed ? (
            <div className={styles.eventWrapper}>
              <div className={styles.eventDesc}>
                <div className={styles.eventName}>{name}</div>
                <div className={styles.eventText}>
                  <p>{description}</p>
                </div>
              </div>

              <div className={styles.eventBottom}>
                <AnnotatedPriceButton
                  collapsed={collapsed}
                  price={price}
                  slug={slug}
                />
              </div>
            </div>
          ) : (
            <div className={styles.eventSolid}>
              <div className={styles.eventName}>{name}</div>
              <div className={styles.eventSolidDesc}>
                <AnnotatedPriceButton
                  collapsed={collapsed}
                  price={price}
                  slug={slug}
                />
                <div className={styles.eventSolidDescText}>
                  <p>{description}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

@withMediaQueries({collapsed: '(max-width: 991px)'}, {collapsed: false})
class EventFeatured extends React.PureComponent {
  static hordeOptionValue = 'Horde';
  static allianceOptionValue = 'Alliance';

  static getFlatOccurrences = (eventGroups, value) => {
    const filteredEventGroups = eventGroups.filter(
      eventGroup => eventGroup.optionValues.find(optionValue => optionValue.value === value)
    );

    const flatEvents = filteredEventGroups
      .reduce(
        (acc, {id, occurrences, productVariant, optionValues}) =>
          occurrences.map(occurrence => ({
            id, occurrence, productVariant, optionValues
          })).concat(acc),
        []
      ).sort(
        (a, b) => (Date.parse(a.occurrence) - Date.parse(b.occurrence)) || a.productVariant.id - b.productVariant.id
      );

    return flatEvents;
  };

  static formatInterval = (interval) => {
    interval = new Date(interval);
    return `${interval.getUTCHours()}h - ${interval.getUTCMinutes()}m - ${interval.getUTCSeconds()}s`;
  };

  constructor(props) {
    super(props);

    this.state = {currentTime: Date.now()};
  }

  updateCurrentTime = () => this.setState({ currentTime: Date.now() });

  componentDidMount() {
    this.updateCurrentTime();
    this._timeTicker = setInterval(this.updateCurrentTime, 1000);
  }

  componentWillUnmount() {
    clearInterval(this._timeTicker);
  }

  render() {
    const {collapsed, image, name, price, slug, taxonSlug, occurrences} = this.props;
    const {currentTime} = this.state;

    const [allianceOccurrence] = EventFeatured.getFlatOccurrences(occurrences, EventFeatured.allianceOptionValue)
      .filter(({occurrence}) => Date.parse(occurrence) > currentTime);
    const [hordeOccurrence] = EventFeatured.getFlatOccurrences(occurrences, EventFeatured.hordeOptionValue)
      .filter(({occurrence}) => Date.parse(occurrence) > currentTime);

    return (
      <div className={styles.eventFeatured}>
        <div className={styles.eventFeaturedWrapper}>
          <div
            className={styles.eventBg}
            style={{backgroundImage: `url(${channelImageUrl(image.path)})`}}
          >
            <div className={styles.eventName}>{name}</div>
            <Link className={styles.eventAction} to={`/service/${slug}`}>
              <span className={styles.eventActionWrapper}>
                <span className={styles.eventActionText}>All raids</span>
                <RightArrowIcon/>
              </span>
            </Link>
          </div>

          <div className={styles.eventOptions}>
            <div className={styles.eventOption}>
              <div className={styles.eventOptionTop}>
                <div className={styles.eventOptionIcon}>
                  <img src={hordeIcon} alt=""/>
                </div>
                <div className={styles.eventOptionInner}>
                  <div className={styles.eventOptionName}>Horde raid</div>
                  <p className={styles.eventOptionText}>
                    starts:
                    {' '}
                    <span className={styles.eventOptionTextAccent}>
                      {hordeOccurrence
                        ? EventFeatured.formatInterval(Date.parse(hordeOccurrence.occurrence) - currentTime)
                        : 'Contact Us'
                      }
                    </span>
                  </p>
                </div>
              </div>

              <div className={styles.eventOptionBottom}>
                <AnnotatedPriceButton
                  collapsed={collapsed}
                  price={price}
                  slug={slug}
                />
              </div>
            </div>

            <div className={styles.eventOption}>
              <div className={styles.eventOptionTop}>
                <div className={styles.eventOptionIcon}>
                  <img src={allianceIcon} alt=""/>
                </div>
                <div className={styles.eventOptionInner}>
                  <div className={styles.eventOptionName}>Alliance raid</div>
                  <p className={styles.eventOptionText}>
                    starts:
                    {' '}
                    <span className={styles.eventOptionTextAccent}>
                      {allianceOccurrence
                        ? EventFeatured.formatInterval(Date.parse(allianceOccurrence.occurrence) - currentTime)
                        : 'Contact Us'
                      }
                    </span>
                  </p>
                </div>
              </div>

              <div className={styles.eventOptionBottom}>
                <AnnotatedPriceButton
                  collapsed={collapsed}
                  price={price}
                  slug={slug}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default class Events extends React.PureComponent {
  static presetName = 'Raids';

  render() {
    const {event, eventOccurrences, products} = this.props;

    return (
      <div className={styles.events}>
        <div className={styles.eventsFeatured}>
          <EventFeatured
            image={event.images[0]}
            name={event.name}
            price={event.price}
            slug={event.slug}
            taxonSlug={event.mainTaxon.slug}
            occurrences={eventOccurrences.filter(occurrence => occurrence.preset.name === Events.presetName)}
          />
        </div>

        <div className={styles.eventsSmaller}>
          <div className={styles.eventsSmallerRow}>
            {products.map(product => (
              <Event
                key={product.code}
                name={product.name}
                description="new group every 15 minutes"
                price={product.price}
                slug={product.slug}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/events/Event.js